var isKind = require('./isKind');
    /**
     */
    function isString(val) {
        return isKind(val, 'String');
    }
    module.exports = isString;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isString.js
// module id = 699
// module chunks = 0 1 2